var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from "@/components/common/Container";
import { Button } from "@/components/ui/Button";
import { CollapsibleContent } from "@/components/ui/Collapsible";
import { useStepperControl } from "@/hooks/useStepperControl";
import { cn } from "@/lib/utils";
import { RequerimentoCNHEnum, RequerimentoPIDEnum, } from "@/models/Requerimento";
import { Collapsible, CollapsibleTrigger } from "@radix-ui/react-collapsible";
import { cva } from "class-variance-authority";
import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";
import { CardNonProcess } from "./components/CardNonProcess";
import { CardProcess } from "./components/CardProcess";
import VerticalExternalTimelineProcess from "./components/VerticalExternalTimelineProcess";
import { VerticalTimelineNegativa } from "./components/VerticalTimelineNegativa";
import { VerticalTimelinePid } from "./components/VerticalTimelinePid";
var collapsableButtonVariants = cva("p-0 max-w-40 justify-start text-etipi-blue text-sm font-medium hover:opacity-85 hover:no-underline active:opacity-65", {
    variants: {
        platform: {
            desktop: "hidden sm:flex",
            mobile: "flex sm:hidden mt-2 -mb-2",
        },
    },
});
var CollapsableButton = React.forwardRef(function (_a, ref) {
    var isOpen = _a.isOpen, platform = _a.platform, props = __rest(_a, ["isOpen", "platform"]);
    return (_jsx(CollapsibleTrigger, __assign({ ref: ref, asChild: true }, { children: _jsxs(Button, __assign({ variant: "link", size: "sm", className: cn(collapsableButtonVariants({ platform: platform })) }, props, { children: ["Exibir Detalhes ", isOpen ? _jsx(ChevronUp, {}) : _jsx(ChevronDown, {})] })) })));
});
CollapsableButton.displayName = "CollapsableButton";
function CollapsableProcessItem(_a) {
    var isOpen = _a.isOpen, handleExpand = _a.handleExpand, idx = _a.idx, item = _a.item;
    return (_jsxs(Collapsible, __assign({ open: isOpen, onOpenChange: function () {
            handleExpand(idx);
        }, className: "w-full max-w-[864px]" }, { children: [_jsx(CardProcess, { data: item, CollapsableBtnDesktop: function () { return (_jsx(CollapsableButton, { isOpen: isOpen, platform: "desktop" })); }, CollapsableBtnMobile: function () { return (_jsx(CollapsableButton, { isOpen: isOpen, platform: "mobile" })); } }), _jsxs(CollapsibleContent, __assign({ className: "p-3 sm:p-6" }, { children: [" ", _jsx("h2", __assign({ className: "font-semibold mb-2 sm:mb-7" }, { children: "Detalhes do Processo" })), _jsx(VerticalExternalTimelineProcess, { data: item })] }))] })));
}
export function ListProcesses() {
    var serviceReturn = useStepperControl().serviceReturn;
    var _a = useState(-1), expandedIndex = _a[0], setExpandedIndex = _a[1];
    var handleExpand = function (index) {
        setExpandedIndex(index === expandedIndex ? -1 : index);
    };
    return (_jsx("div", __assign({ className: "flex flex-col justify-center" }, { children: _jsxs(Container, { children: [_jsx("h1", __assign({ className: "text-center text-2xl font-semibold" }, { children: "Acompanhar Protocolo" })), serviceReturn.length > 0 &&
                    (serviceReturn === null || serviceReturn === void 0 ? void 0 : serviceReturn.map(function (item, idx) {
                        if (item.codigoRequerimento === RequerimentoCNHEnum.NEGATIVA_CNH) {
                            return (_jsxs(Collapsible, __assign({ open: expandedIndex === idx, onOpenChange: function () {
                                    handleExpand(idx);
                                }, className: "w-full max-w-[864px]" }, { children: [_jsx(CardNonProcess, { data: item, CollapsableBtnDesktop: function () { return (_jsx(CollapsableButton, { isOpen: expandedIndex === idx, platform: "desktop" })); }, CollapsableBtnMobile: function () { return (_jsx(CollapsableButton, { isOpen: expandedIndex === idx, platform: "mobile" })); } }), _jsxs(CollapsibleContent, __assign({ className: "p-3 sm:p-6" }, { children: [" ", _jsx("h2", __assign({ className: "font-semibold mb-2 sm:mb-7" }, { children: "Detalhes do Processo" })), _jsx(VerticalTimelineNegativa, { data: item })] }))] }), idx + item.dataProcesso));
                        }
                        if (item.codigoRequerimento === RequerimentoPIDEnum.OBTER_PID) {
                            return (_jsxs(Collapsible, __assign({ open: expandedIndex === idx, onOpenChange: function () {
                                    handleExpand(idx);
                                }, className: "w-full max-w-[864px]" }, { children: [_jsx(CardNonProcess, { data: item, CollapsableBtnDesktop: function () { return (_jsx(CollapsableButton, { isOpen: expandedIndex === idx, platform: "desktop" })); }, CollapsableBtnMobile: function () { return (_jsx(CollapsableButton, { isOpen: expandedIndex === idx, platform: "mobile" })); } }), _jsxs(CollapsibleContent, __assign({ className: "p-3 sm:p-6" }, { children: [" ", _jsx("h2", __assign({ className: "font-semibold mb-2 sm:mb-7" }, { children: "Detalhes do Processo" })), _jsx(VerticalTimelinePid, { data: item })] }))] }), idx + item.dataProcesso));
                        }
                        return (_jsx(CollapsableProcessItem, { isOpen: expandedIndex === idx, handleExpand: handleExpand, idx: idx, item: item }, idx + item.dataProcesso));
                    }))] }) })));
}
